import setupPdf from './setup-pdf';

const { renderPdf, printPdf, loadPdfJsLib } = setupPdf();
export { renderPdf, printPdf, loadPdfJsLib };
